<div id="changePassword" class="changePassword-container ya-typography" (swiperight)="SwiperNavigateBack()">
  <ya-subheader class="header-title-wrapper" [hasContent]="true" [disableNavigateBack]="true"
    (onNavigateBackClick)="navigateBack()">
    <h2 class="header-title" langkey="phChangePassword_Title"></h2>
  </ya-subheader>
  <div class="ya-page-content ya-page-content--padding ya-page-content--webshop">
    <div class="content-message">
      <span langkey="phChangePassword_Message"></span>
    </div>
    <form #changePasswordForm="ngForm" class="form-wrapper" novalidate>
      <div class="oldPassword-wrapper">
        <ya-customInput name="oldPassword" inputType="password" [(ngModel)]="oldPassword"
          inputPlaceholder="phChangePassword_Label_OldPassword" required>
          <ng-container *ngIf="changePasswordForm.form.controls['oldPassword']">
            <ya-errorvalidation
              [controlValidation]="changePasswordForm.form.controls['oldPassword'].invalid && changePasswordForm.form.controls['oldPassword'].touched"
              errorMessage="phChangePassword_Validate_Password_Required"></ya-errorvalidation>
          </ng-container>
        </ya-customInput>
      </div>
      <ya-customInput name="newPassword" inputType="password" [(ngModel)]="newPassword" #newPasswordCtrl="ngModel"
        inputPlaceholder="phChangePassword_Label_NewPassword" appPasswordValidator required>
        <ng-container *ngIf="changePasswordForm.form.controls['newPassword']">
          <ya-errorvalidation
            [controlValidation]="changePasswordForm.form.controls['newPassword'].invalid && changePasswordForm.form.controls['newPassword'].touched"
            errorMessage="phChangePassword_Validate_Password"></ya-errorvalidation>
        </ng-container>
      </ya-customInput>
      <ya-customInput name="confirmPassword" inputType="password" [(ngModel)]="confirmPassword"
        inputPlaceholder="phChangePassword_Label_NewPassword" [appEmailConfirmation]="newPasswordCtrl.value" required>
        <ng-container *ngIf="changePasswordForm.form.controls['confirmPassword']">
          <ya-errorvalidation
            [controlValidation]="changePasswordForm.form.controls['confirmPassword'].invalid && changePasswordForm.form.controls['confirmPassword'].touched"
            errorMessage="phChangePassword_Confirm_Password"></ya-errorvalidation>
        </ng-container>
      </ya-customInput>
      <div class="ya-webshop-button-container">
        <ng-container *ngIf="changePasswordForm.valid; then activeButton else deactiveButton">
        </ng-container>
        <ng-template #activeButton>
          <button mat-flat-button (click)="changePassword()">
            <span langkey="phChangePassword_ChangePassword_button"></span>
          </button>
        </ng-template>
        <ng-template #deactiveButton>
          <span (click)="showValidationMessage(changePasswordForm)">
            <button mat-flat-button disabled>
              <span langkey="phChangePassword_ChangePassword_button"></span>
            </button>
          </span>
        </ng-template>
      </div>
    </form>
  </div>
</div>